export interface ConsentState {
  necessary: true;
  analytics: boolean;
  marketing: boolean;
  updatedAt: string;
}

const COOKIE_NAME = 'cookie_consent';
const TTL_DAYS = 180;

function isReactSnap(): boolean {
  return typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';
}

export function getConsent(): ConsentState | null {
  if (isReactSnap()) return null;
  try {
    const raw = document.cookie
      .split('; ')
      .find((c) => c.startsWith(`${COOKIE_NAME}=`));
    if (!raw) return null;
    const value = decodeURIComponent(raw.split('=')[1]);
    return JSON.parse(value) as ConsentState;
  } catch {
    return null;
  }
}

export function setConsent(state: ConsentState): void {
  if (isReactSnap()) return;
  const expires = new Date(Date.now() + TTL_DAYS * 864e5).toUTCString();
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  const value = encodeURIComponent(JSON.stringify(state));
  document.cookie = `${COOKIE_NAME}=${value}; expires=${expires}; path=/; SameSite=Lax${secure}`;
}

export function acceptAll(): ConsentState {
  const state: ConsentState = {
    necessary: true,
    analytics: true,
    marketing: true,
    updatedAt: new Date().toISOString(),
  };
  setConsent(state);
  return state;
}

export function rejectOptional(): ConsentState {
  const state: ConsentState = {
    necessary: true,
    analytics: false,
    marketing: false,
    updatedAt: new Date().toISOString(),
  };
  setConsent(state);
  return state;
}
